import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import { getAutomationSettingCounts } from '@ebalance/proto/bffuser/v1/workflow_automation_service-WorkflowAutomationService_connectquery'
import { GetAutomationSettingCountsRequestSchema } from '@ebalance/proto/bffuser/v1/workflow_automation_service_pb'

export type AutomationSettingCounts =
  /** 取得中・取得失敗。 件数を 0 と読ませないため、 件数を持たない */
  | { status: 'unknown' }
  | {
      status: 'ready'
      autoBidRuleCount: number
      planAutomatedSubStepCount: number
    }

const REQUEST = create(GetAutomationSettingCountsRequestSchema, {})

/**
 * 自動化の設定への入口に添える件数 (AC-AEH-010)。 履歴の取得とは別の query にし、
 * 件数の失敗で履歴の表示を変えない。 retry の回数は共通の retry policy に任せる。
 */
export function useAutomationSettingCounts(): AutomationSettingCounts {
  const result = useQuery(getAutomationSettingCounts, REQUEST, {
    throwOnError: false,
  })
  if (result.isError || result.data === undefined) return { status: 'unknown' }
  return {
    status: 'ready',
    autoBidRuleCount: result.data.autoBidRuleCount,
    planAutomatedSubStepCount: result.data.planAutomatedSubStepCount,
  }
}
